<div class="container">
  <div class="modal">
    <h1 *ngIf="title" class="modal__header">
      {{title}}
    </h1>
    <div class="modal__content">
      <p [innerHTML]="description"></p>
    </div>

    <div class="modal__footer">
      <ion-button color="clear" (click)="cancel()">Cancel</ion-button>
      <ion-button color="dark" (click)="ok()">Ok</ion-button>
    </div>
  </div>
</div>